export default __webpack_public_path__ + "static/media/noFilterFound.8cc75cf6.svg";